"use client";

import Image from "next/image";
import { Tooltip } from "@tillix/ui-atoms/tooltip";
import { bankInitials } from "@tillix/utils";
import type { BankLookupResult } from "../hooks/useBankByRoutingNumber";

export interface BankBadgeProps {
  bank: BankLookupResult | null;
  isLoading: boolean;
}

export function BankBadge({ bank, isLoading }: BankBadgeProps) {
  if (isLoading) {
    return (
      <span
        aria-hidden="true"
        className="inline-block h-5 w-12 animate-pulse rounded bg-muted"
      />
    );
  }

  if (!bank) return null;

  const visual = bank.svg ? (
    <Image
      alt={bank.name}
      className="h-7 max-w-14 object-contain"
      height={28}
      src={`data:image/svg+xml;base64,${bank.svg}`}
      width={28}
    />
  ) : (
    <span
      aria-hidden="true"
      className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-muted font-semibold text-[10px]"
    >
      {bankInitials(bank.name)}
    </span>
  );

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <span
            aria-label={bank.name}
            className="inline-flex items-center"
            role="img"
          />
        }
      >
        {visual}
      </Tooltip.Trigger>
      <Tooltip.Popup>{bank.name}</Tooltip.Popup>
    </Tooltip>
  );
}
